module.exports = __webpack_public_path__ + "static/img/QR.f0ee31c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QR.jpg
// module id = 3k6D
// module chunks = 1